// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation'; // Import the new Navigation component
import Home from './components/Home';
import Publications from './components/Publications';
import Footer from './components/Footer';
import Contact from './components/Contact';
import NotFound from './components/NotFound';


function App() {
  return (
    <Router>
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Navigation /> {/* Render the Navigation component here */}

        <main style={{ flex: 1 }} className="container mt-3">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/publications" element={<Publications />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;